import {Dialog} from '@common/ui/overlays/dialog/dialog';
import {DialogHeader} from '@common/ui/overlays/dialog/dialog-header';
import {Trans} from '@common/i18n/trans';
import {DialogBody} from '@common/ui/overlays/dialog/dialog-body';
import {useDialogContext} from '@common/ui/overlays/dialog/dialog-context';
import {useForm} from 'react-hook-form';
import {
  CreateCategoryPayload,
  useCreateCategory,
} from '@app/blog/category/use-create-category';
import {Form} from '@common/ui/forms/form';
import {DialogFooter} from '@common/ui/overlays/dialog/dialog-footer';
import {Button} from '@common/ui/buttons/button';
import {useAuth} from '@common/auth/use-auth';
import {Fragment} from 'react';
import {FormTextField} from '@common/ui/forms/input-field/text-field/text-field';
import { useParams } from 'react-router-dom';

export function CreateCategoryDialog() {
  const {formId, close} = useDialogContext();
  const { site_id } = useParams();
  const {user} = useAuth();
  const form = useForm<CreateCategoryPayload>({
    defaultValues: {
      project_id: site_id ? parseInt(site_id, 10) : undefined
    },
  });
  const createCategory = useCreateCategory(form);
  return (
    <Dialog>
      <DialogHeader>
        <Trans message="New Category" />
      </DialogHeader>
      <DialogBody>
        <Form
          id={formId}
          form={form}
          onSubmit={value => {
            createCategory.mutate(value, {
              onSuccess: () => close(),
            });
          }}
        >
          <Fragment>
            <FormTextField
              autoFocus
              name="name"
              label={<Trans message="Name" />}
              className="mb-14"
              required
            />
          </Fragment>
        </Form>
      </DialogBody>
      <DialogFooter>
        <Button onClick={() => close()}>
          <Trans message="Cancel" />
        </Button>
        <Button
          form={formId}
          type="submit"
          variant="flat"
          color="primary"
          disabled={createCategory.isPending}
        >
          <Trans message="Create" />
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
